import { useEffect } from 'react';

const notifyParent = (parent) => (message) => {
  console.log(parent);
  window.parent.postMessage(message, parent);
};

// We have to keep this task list up-to-date with the website's checklist
const [SEND_MESSAGE] = ['customer-send-message'];

export const useChecklist = (customerClient, targetOrigin) => {
  useEffect(() => {
    const notify = notifyParent(targetOrigin);
    const handleNewEvent = ({ type }) => {
      switch (type) {
        case 'message.new':
          console.log(`New Message`)
          console.log(`Target Origin: ${targetOrigin}`)
          console.log(`Tar`)
          notify(SEND_MESSAGE);
          break;
        default:
          break;
      }
    };
    if (customerClient) {
      customerClient.on(handleNewEvent);
    }
    return () => customerClient?.off(handleNewEvent);
  }, [customerClient, targetOrigin]);
};
